export const micrositeConfigMessagePrefix = 'micrositeConfig'
